<script type="text/ecmascript-6">
import GeneralMixin from "JS/mixins/campaign/general";

export default {
  name: "Content",
  mixins: [GeneralMixin],
  props: {
    content: {
      required: true,
      type: String
    },
    descriptionCollapseLabel: {
      required: true,
      type: String
    },
    descriptionExpandLabel: {
      required: true,
      type: String
    },
    enDefaultCollapsedDescription: {
      required: true,
      type: Boolean
    },
    heading: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      /**
       * The content-toggling approach is only applicable on smaller screens;
       * on larger screens, the visibility is handled in CSS with !important
       */
      contentIsVisible: !this.enDefaultCollapsedDescription
    };
  },
  computed: {
    toggleContentLabel() {
      return this.contentIsVisible
        ? this.descriptionCollapseLabel
        : this.descriptionExpandLabel;
    }
  },
  methods: {
    toggleContent() {
      this.contentIsVisible = !this.contentIsVisible;
    }
  }
};
</script>
